import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/layout/Navbar";
import { Footer } from "../components/layout/Footer";
import { Hero } from "../components/sections/Hero";
import { Story } from "../components/sections/Story";
import { Bottle } from "../components/sections/Bottle";
import { CoBranding } from "../components/sections/CoBranding";
import { UseCases } from "../components/sections/UseCases";
import { Marquee } from "../components/sections/Marquee";
import { Sustainability } from "../components/sections/Sustainability";
import { Process } from "../components/sections/Process";
import { Alkaline } from "../components/sections/Alkaline";
import { PartnerCTA } from "../components/sections/PartnerCTA";
import { BottleDetails } from "../components/panels/BottleDetails";
import { CoBrandDetails, SustainDetails, ProcessDetails } from "../components/panels/InfoPanels";
import { EnquiryModal } from "../components/panels/EnquiryModal";
import { scrollToId } from "../lib/api";

export default function Home() {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 400);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Story />
        <Bottle />
        <CoBranding />
        <UseCases />
        <Marquee />
        <Sustainability />
        <Process />
        <Alkaline />
        <PartnerCTA />
      </main>
      <Footer />
      <BottleDetails />
      <CoBrandDetails />
      <SustainDetails />
      <ProcessDetails />
      <EnquiryModal />
    </>
  );
}
